module.exports = __webpack_public_path__ + "static/img/bg.667cf6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = 65
// module chunks = 2